import React, { useState } from "react";
import { Text } from "react-internationalization";
import ProgressModal from "./ProgressModal";
import { connect,useSelector } from "react-redux";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
const SaveProgress = (props) => {
  const [isOpen, setOpen] = useState(false);
  const {preEnrollInfo } = useSelector((state1) => state1.webApp);
  const lang = useSelector((state) => state.webApp.language);
  const { isPage } = useSelector((state) => state.spinner);
  const [snackbar, setsnackbar] = useState({
    snackBarOpen: false,
    snackBarMsg: "",
    snackBarSeverty: "",
    vertical: "top",
    horizontal: "center",
  });
  const handleClose = (event, reason) => {
    setsnackbar({
      snackBarOpen: false,
      snackBarSeverty:"",
      snackBarMsg: "",
    vertical: "top",
    horizontal: "center",
    });
  };
  return (
    <>
    <Snackbar
        open={snackbar.snackBarOpen}
        //  autoHideDuration={6000}
        onClose={handleClose}
        autoHideDuration={4000}
        anchorOrigin={{ vertical:"top", horizontal:"center" }}
        key={snackbar.vertical + snackbar.horizontal}
      >
        <Alert onClose={handleClose} severity={snackbar.snackBarSeverty}>
          {snackbar.snackBarMsg}
        </Alert>
      </Snackbar>
     {(preEnrollInfo?.appStatus!="READY" && preEnrollInfo?.appStatus!="SUBMITTED") &&
      <a
        href="none"
        data-bs-toggle="modal"
        data-bs-target="#save_your_progress_window"
        onClick={(e) => {
          e.preventDefault();
          {isPage === "enrollOnline"?
          props?.state?.data?.emailAddress?
          setOpen(true)
          : setsnackbar({
            snackBarOpen: true,
            snackBarMsg:
              lang === "es"
                ?"Por favor complete la dirección de correo electrónico en el formulario de inscripción"
                : "Please fill email address in enrollment form",
            snackBarSeverty: "error",
          })
          : setOpen(true)
        
        }
        }}
      >
        <Text id="sharp.saveMyPro" /> <i className="icon icon-right-big" />
      </a>
}
      <ProgressModal
        isOpen={isOpen}
        setOpen={setOpen}
        customerId={props.customerId}
        zip={props.zipCode}
        CountyCd={props.CountyCd}
        stateCd={props.stateCd}
        countyName={props.countyName}
        email={props.email}
        selectedPlansForCompare={props.selectedPlansForCompare}
        productCategory={props.productCategory}
        selectedPlanName={props.selectedPlanName}
        planCardData={props.cardDetails}
        state={props.state}
        userId={props.userId==="Guest"?"":props.userId}
        getData={props.getData}
        lang={props.lang}
        year={props.year}
      />
    </>
  );
};
const mapStateToProps = (state) => {
  const { CountyCd,stateCd } = state.webApp;
  return {
    cardDetails: state.webApp.planCardData,
    zipCode: state.webApp.zip,
    guestLoggedIn: state.login.guestLogin,
    stateName: state.webApp.state,
    countyName: state.webApp.county?.countyName
      ? state.webApp.county?.countyName
      : state.webApp.county,
    email:
      state.login.emailAddress.length > 0
        ? state.login.emailAddress
        : state.login.email,
    customerId: state.login.customerId,
    userId: state.login.userId,
    planId: state.webApp.emailPlanId,
    agentLogin: state.login.agentLoggedIn,
    ZipCodes: state.webApp.zipCodes,
    county: state.webApp.county,
   // selectedPlanName,
    // county,
    CountyCd,
    stateCd,
    deeplink: state.login.deeplink,
    dpcountyName: state.login.dpcountyName,
    dpzipCode: state.login.dpzipCode,
    dpProductId: state.login.dpProductId,
    countyCode: state.webApp.countyCode,
    // customerId:state.login.customerId,
    theme: state.login.theme,
    prospectEnroll: state.webApp.prospectEnroll,
    selectedPlansForCompare: state.webApp.selectedPlansForCompare,
    //selectedPlanDetails: state.webApp.selectedPlanDetails,
    lang: state.webApp.language, 
    productCategory: state.login.productCategory,
    selectedPlanName: state.login.selectedPlanName?state.login.selectedPlanName:state.webApp.preEnrollInfo?.planName,
    year: state.webApp.year?.planYear
    ? state.webApp.year?.planYear
    : state.webApp.year,
  };
};
export default connect(mapStateToProps)(SaveProgress);
